import React from 'react';
import { Modal, Button, Fade, Box, Typography, Avatar, CardContent, Backdrop} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Card, CardHeader, CardBody, Media } from 'reactstrap';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { baseUrl } from '../shared/baseUrl';

const person = [
  {
    image: '',
    name: 'Dr. Plaban Kr. Bhowmik',
    designation: 'Assistant Professor, IIT Kharagpur',
    description: '',
  },
  {
    image: '',
    name: 'Dr. Kaushal Kr. Bhagat',
    designation: 'Assistant Professor, IIT Kharagpur',
    description: '',
  },
  {
    image: '',
    name: 'Nitesh Jha',
    designation: 'Senior Research Fellow, IIT Kharagpur',
    description: 'Email id: nitesh.jha1092@gmail.com, Phone No: 8601547787 / 8328917617',
  },
];

const RenderLeader=(leader)=>{
    const lead = leader.map((leader, index) => {
        return (
            <Media tag="li" key={index}>
                <Media left middle>
                    <Avatar alt={leader.name} src={`${baseUrl}assets/images/avatar.png`} />
                </Media> 
                <Media body className="ml-5 mb-4">
                    <Media heading>{leader.name}</Media>
                    <Media className="mb-2">{leader.designation}</Media>
                    <Media>{leader.description}</Media>
                </Media>    
            </Media> 
        );
    });

    return(
        <Media list>
            {lead}
        </Media>
    );
}

const StyledPaper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: '2px solid #000',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
}));

const StyledModal = styled('div')({
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '5%',
  //left: '10%',
  overflowY: 'scroll',
  height: '100%',
  display: 'block',
});

const AboutModal = ({ open, handleClose }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="form-dialog-title2"
      aria-describedby="simple-modal-description"
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <StyledModal>
        <Fade in={open}>
          <StyledPaper>
            <blockquote className="blockquote">
              <div className="row row-content">
                <div className="col-12 col-md-2"></div>
                <div className="col-12 col-md-8">
                  <div className="text-center mb-3">
                    <h2>About Us</h2>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <h5 id="simple-modal-description">
                    <Button onClick={handleClose} color="primary" variant="contained">
                      Close
                    </Button>
                  </h5>
                </div>
              </div>
              <div className="row row-content">
                <div className="col-12 col-md-12">
                  <div className="text-center mb-3">
                    <h4>What is Computational Thinking?</h4>
                  </div>
                  <p>
                    Computational thinking (CT) is an interrelated set of skills and practices for solving complex problems, a way to learn topics in many disciplines, and a necessity for fully participating in a computational world.
                  </p>
                </div>
                <div className="col-12 col-md-6">
                  <h4>Some benefits of Computational thinking</h4>
                  <div className="row-md-6">
                    <dt className="col-12"><em>Move students beyond technology literacy</em></dt>
                    <dt className="col-12"><p><em>Create problem solvers instead of software users</em></p></dt>
                    <dt className="col-12">
                      <h5 className="mb-0">Lower-level processes</h5>
                      <blockquote className="blockquote">
                        <p>- using basic facts, skills</p>
                      </blockquote>
                      <h5 className="mb-0">Higher-level processes</h5>
                      <blockquote className="blockquote">
                        <p>- doing something complex with information</p>
                      </blockquote>
                      <h5 className="mb-0">Computational thinking is a <em>higher-level</em> cognitive process</h5>
                      <blockquote className="blockquote">
                        <p>- manipulating data/information to see patterns</p>
                        <p>- involves thinking, reasoning, and abstraction</p>
                      </blockquote>
                    </dt>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <img alt="CTImage" height="400" className="card-img-top" src={`${baseUrl}assets/images/ctimage.PNG`} />
                </div>
                <br />
                <br />
                <div className="col-12 col-md-12">
                  <div className="text-center mb-3">
                    <h4>Computational Thinking Steps</h4>
                  </div>
                  <p>There are four core steps/pillars of Computational Thinking.</p>
                </div>
                <br />
                <div className="col-12 col-md-6">
                  <img alt="CTImage" className="card-img-top" src={`${baseUrl}assets/images/ctsteps.PNG`} />
                </div>
                <div className="col-12 col-md-6">
                  <img alt="CTskill" className="card-img-top" src={`${baseUrl}assets/images/CTskill.png`} />
                </div>
                <div className="col-12 col-md-12">
                  <div className="text-center mb-3">
                    <h4>How CT-Onlinq works</h4>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <p className="mb-0">
                    The platform is based on Computational thinking integrated with inquiry-based learning approach.
                  </p>
                  <p>
                    Computational thinking is one of the important skills for problem-solving and decision-making through a systematic approach that can be implemented by an information processing agent.
                  </p>
                  <p>
                    Inquiry-based learning uses discoverable learning approach, where students creates hypothesis, designs, develops experiments and formulates evidence-based arguments to explore a research question.
                  </p>
                  <p>
                    The design of the system is based on 6 steps in Computational thinking based on inquiry steps. Each activity in the platform follows the below steps:
                  </p>
                </div>
                <div className="col-12 col-md-3"></div>
                <div className="col-12 col-md-6">
                  <Card>
                    <CardHeader className="bg-success text-white"><h3 className="text-center">System workflow</h3></CardHeader>
                    <CardContent>
                      <dl className="row p-1">
                        <dt className="col-12"><h4 className="text-center">Problem decomposition</h4></dt>
                        <dt className="col-12"><div className="text-center"><ArrowDownwardIcon /></div></dt>
                        <dt className="col-12"><h4 className="text-center">Pattern recognition</h4></dt>
                        <dt className="col-12"><div className="text-center"><ArrowDownwardIcon /></div></dt>
                        <dt className="col-12"><h4 className="text-center">Abstraction</h4></dt>
                        <dt className="col-12"><div className="text-center"><ArrowDownwardIcon /></div></dt>
                        <dt className="col-12"><h4 className="text-center">Algorithm Design</h4></dt>
                        <dt className="col-12"><div className="text-center"><ArrowDownwardIcon /></div></dt>
                        <dt className="col-12"><h4 className="text-center">Analysis of Algorithm</h4></dt>
                        <dt className="col-12"><div className="text-center"><ArrowDownwardIcon /></div></dt>
                        <dt className="col-12"><h4 className="text-center">Comparison of algorithms</h4></dt>
                      </dl>
                    </CardContent>
                  </Card>
                </div>
                <div className="col-12 col-md-12">
                  <blockquote className="blockquote">
                    <p className="mb-0">
                      "Computational thinking will be a fundamental skill by the middle of 21st Century. Just like reading, writing and arithmetic."
                    </p>
                    <footer className="blockquote-footer">
                      Jennifer M Wing, <cite title="Source Title">Computational Thinking (2011).</cite>
                    </footer>
                  </blockquote>
                </div>
                <div className="col-12">
                  <Card>
                    <CardHeader className="bg-info text-white">Developers and Designers</CardHeader>
                    <CardBody>
                      {RenderLeader(person)}
                    </CardBody>
                  </Card>
                </div>
                <div className="col-12">
                  <Button onClick={handleClose} color="primary" variant="contained">
                    Close
                  </Button>
                </div>
              </div>
            </blockquote>
          </StyledPaper>
        </Fade>
      </StyledModal>
    </Modal>
  );
};

export default AboutModal;